import { GlobalConstants } from "./GlobalConstants";

export const GlobalStoreConstants = {
  "metadataApi": "metadata/list"
};

export const FilterOptions = {
  DATE_FILTER_OPTIONS: [
    {
      text: "Equals",
      value: "Equals",
      fields: [{ label: "Equals", value: "", id: "Equals" }],
    },
    {
      text: "Does not equal",
      value: "Does not equal",
      fields: [{ label: "Does not equal", value: "", id: "Does not equal" }],
    },
    {
      text: "Between",
      value: "Between",
      fields: [
        { label: "From", value: "", id: "From" },
        { label: "To", value: "", id: "To" },
      ],
    },
    {
      text: "Before",
      value: "Before",
      fields: [
        {
          label: "Before",
          value: "",
          id: "Before",
        },
      ],
    },
    {
      text: "After",
      value: "After",
      fields: [
        {
          label: "After",
          value: "",
          id: "After",
        },
      ],
    }
  ],
  AMOUNT_FILTER_OPTIONS: [
    {
      text: "Equals",
      value: "Equals",
      fields: [{ label: "Equals", value: "", id: "Equals" }],
    },
    {
      text: "Does not Equal",
      value: "Does not Equal",
      fields: [{ label: "Does not Equal", value: "", id: "Does not Equal" }],
    },
    {
      text: "Between",
      value: "Between",
      fields: [
        { label: "Greater than", value: "", id: "Greater than" },
        { label: "Less than", value: "", id: "Less than" },
      ],
    },
    {
      text: "Less than",
      value: "Less than",
      fields: [{ label: "Less than", value: "", id: "Less than" }],
    },
    {
      text: "Greater than",
      value: "Greater than",
      fields: [{ label: "Greater than", value: "", id: "Greater than" }],
    }
  ],
  CHANNEL_OPTIONS: ["Fix and Flip", "Inside Sales", "Retail", "Wholesale"],
  ASSIGNED_TO: [
    { name: "Unassigned", role: "Loan Officer", id: "ffad647c-1596-4f1a-b4d4-1d5494541bb7" },
    { name: "Alissa McCord", role: "Loan Officer", id: "ffad647c-1596-4f1a-b4d4-1d5494541bb7" },
    { name: "Courtney Altig", role: "Loan Officer", id: "ffad647c-1596-4f1a-b4d4-1d5494541bb7" },
    { name: "Unassigned", role: "Processors", id: "ffad647c-1596-4f1a-b4d4-1d5494541bb7" },
    { name: "Keiandre", role: "Processors", id: "ffad647c-1596-4f1a-b4d4-1d5494541bb7" },
    { name: "George Flint", role: "", id: "ffad647c-1596-4f1a-b4d4-1d5494541bb7" },
    { name: "Cassie Bush", role: "", id: "ffad647c-1596-4f1a-b4d4-1d5494541bb7" }
  ],
  LOAN_PROGRAM: ["All in One", "Bridge", "Bridge to Build", "Development", "Fix and Flip", "New Construction"],
};

export const LmsFilters = [
  {
    title: "Channel",
    filterType: "checkbox",
    mappingKey: "channel",
    isDisabled: false,
    options: [
      { label: "Fix and Flip", value: false },
      { label: "Inside Sales", value: false },
      { label: "Retail", value: false },
      { label: "Wholesale", value: false },
    ],
  },
  {
    title: "Assigned To",
    filterType: "checkbox",
    mappingKey: "assignedTo",
    isDisabled: false,
    options: [
      {
        label: "Loan Officers",
        value: false,
        isCollapsed: false,
        subgroupOptions: [
          { label: "Unassigned", value: false },
          { label: "Alissa McCord", value: false },
          { label: "Courtney Altig", value: false },
        ],
      },
      {
        label: "Processors",
        value: false,
        isCollapsed: false,
        subgroupOptions: [
          { label: "Unassigned", value: false },
          { label: "Keiandre", value: false },
        ],
      },
      { label: "George Flint", value: false },
      { label: "Cassie Bush", value: false },
    ],
  },
  {
    title: "Loan Program",
    filterType: "checkbox",
    mappingKey: "loanProgram",
    isDisabled: false,
    options: [
      { label: "All in One", value: false },
      { label: "Bridge", value: false },
      { label: "Bridge to Build", value: false },
      { label: "Development", value: false },
      { label: "Fix and Flip", value: false },
      { label: "New Construction", value: false },
    ],
  },
  {
    title: "Statuses",
    filterType: "checkbox",
    mappingKey: "statuses",
    isDisabled: false,
    options: [
      { label: "Application | Active", value: false },
      { label: "Prescreener | Active", value: false },
      { label: "Underwriting | Active", value: false },
      { label: "UW Restructure | Sales", value: false },
      { label: "LRC Voting | Full UW", value: false },
    ],
  },
  {
    title: "Closing Date",
    filterType: "date",
    mappingKey: "closingDate",
    selectedIndex: 0,
    isDisabled: false,
    value: FilterOptions.DATE_FILTER_OPTIONS[0].value,
    options: FilterOptions.DATE_FILTER_OPTIONS,
  },
  {
    title: "Amount",
    filterType: "amount",
    mappingKey: "amount",
    selectedIndex: 0,
    isDisabled: false,
    value: FilterOptions.AMOUNT_FILTER_OPTIONS[0].value,
    options: FilterOptions.AMOUNT_FILTER_OPTIONS,
  },
];

export const BrokerFilters = [
  {
    title: "Channel",
    filterType: "checkbox",
    mappingKey: "channel",
    isDisabled: false,
    isHidden: true,
    options: [
      { label: "Fix and Flip", value: false },
      { label: "Inside Sales", value: false },
      { label: "Retail", value: false },
      { label: "Wholesale", value: false },
    ],
  },
  {
    title: "Assigned To",
    filterType: "checkbox",
    mappingKey: "assignedTo",
    isDisabled: false,
    isHidden: true,
    options: [
      {
        label: "Loan Officers",
        value: false,
        isCollapsed: false,
        subgroupOptions: [
          { label: "Unassigned", value: false },
          { label: "Alissa McCord", value: false },
          { label: "Courtney Altig", value: false },
        ],
      },
      {
        label: "Processors",
        value: false,
        isCollapsed: false,
        subgroupOptions: [
          { label: "Unassigned", value: false },
          { label: "Keiandre", value: false },
        ],
      },
      { label: "George Flint", value: false },
      { label: "Cassie Bush", value: false },
    ],
  },
  {
    title: "Loan Program",
    filterType: "checkbox",
    mappingKey: "loanProgram",
    isDisabled: false,
    isHidden: false,
    options: [
      { label: "All In One", value: false },
      { label: "Bridge", value: false },
      { label: "Bridge to Build", value: false },
      { label: "Development", value: false },
      { label: "Fix and Flip", value: false },
      { label: "New Construction", value: false },
    ],
  },
  {
    title: "Statuses",
    filterType: "checkbox",
    mappingKey: "statusLookupName",
    isDisabled: false,
    isHidden: false,
    options: [
      { label: "New", value: false },
      { label: "Sent", value: false },
      { label: "Accepted", value: false }
    ],
  },
  {
    title: "Closing Date",
    filterType: "date",
    mappingKey: "closingDate",
    selectedIndex: 0,
    isDisabled: false,
    isHidden: true,
    value: FilterOptions.DATE_FILTER_OPTIONS[0].value,
    options: FilterOptions.DATE_FILTER_OPTIONS,
  },
  {
    title: "Amount",
    filterType: "amount",
    mappingKey: "amount",
    selectedIndex: 0,
    isDisabled: false,
    isHidden: false,
    value: FilterOptions.AMOUNT_FILTER_OPTIONS[0].value,
    options: FilterOptions.AMOUNT_FILTER_OPTIONS,
  },
];

export const FiltersList = {
  [GlobalConstants.Portals.BORROWER]: [],
  [GlobalConstants.Portals.BROKER]: [],
  [GlobalConstants.Portals.LOAN_OFFICER]: [],
  [GlobalConstants.Portals.LMS]: [],
};

export const FiltersDataModel = [
  {
    title: "Channel",
    filterType: "checkbox",
    mappingKey: "channels",
    isDisabled: false,
    isHidden: false,
    options: [],
  },
  {
    title: "Assigned To",
    filterType: "checkbox",
    mappingKey: "assignedTo",
    isDisabled: false,
    isHidden: false,
    options: [],
  },
  {
    title: "Loan Program",
    filterType: "checkbox",
    mappingKey: "loanProgram",
    metadataKey: "loanPrograms",
    isDisabled: false,
    isHidden: false,
    options: [],
  },
  {
    title: "Closing Date",
    filterType: "date",
    mappingKey: "closingDate",
    selectedIndex: 0,
    isDisabled: false,
    isHidden: true,
    value: FilterOptions.DATE_FILTER_OPTIONS[0].value,
    options: FilterOptions.DATE_FILTER_OPTIONS,
  },
  {
    title: "Amount",
    filterType: "amount",
    mappingKey: "amount",
    selectedIndex: 0,
    isDisabled: false,
    isHidden: false,
    value: FilterOptions.AMOUNT_FILTER_OPTIONS[0].value,
    options: FilterOptions.AMOUNT_FILTER_OPTIONS,
  },
];